import { Controller } from '@hotwired/stimulus';
import copyText from '../bundles/utilities/clipboard';
import useTemporaryContent from '../bundles/controllers/mixins/use_temporary_content';

export default class extends Controller {
  static targets = ['text'];

  static values = {
    data: String,
  };

  async copy(event) {
    event.preventDefault();
    const success = await copyText(this.dataValue);
    if (success) {
      useTemporaryContent(this, this.hasTextTarget ? this.textTarget : this.element, 'Copied!', 3000);
    }
  }
}
